import { LocalizedEntranceTicketTypeBackOffice } from 'apollo/localizedTypes';
import { FormFields } from 'components/UI/Form/types';
import requiredDefaultLanguage from 'utils/i18n/requiredDefaultLanguage';
import isEmptyRichText from 'utils/i18n/isEmptyRichText';
import toFormLocalizedText from 'utils/i18n/toFormLocalizedText';
import { ReactNode } from 'react';
import * as featureTexts from 'assets/texts/ticketFeatures';

const entranceFormFields = (
  isCreation: boolean,
  editableRow?: LocalizedEntranceTicketTypeBackOffice,
  uploadelement?: ReactNode
): FormFields[] => {
  const formFields = [
    {
      name: 'name',
      label: 'Nombre Ticket',
      type: 'localizedText',
      initialValue: editableRow?.name,
      rules: [requiredDefaultLanguage('Campo requerido')],
    },
    {
      name: 'adultValue',
      label: 'Precio ticket adultos',
      type: 'number',
      initialValue: editableRow?.adultValue,
      rules: [
        {
          required: isCreation,
          type: 'number' as const,
          min: 0,
          transform: (value: unknown) => Number(value),
        },
      ],
    },
    {
      name: 'otherValue',
      label: 'Precio adulto mayor o niños',
      type: 'number',
      initialValue: editableRow?.otherValue,
      rules: [
        {
          required: isCreation,
          type: 'number' as const,
          min: 0,
          transform: (value: unknown) => Number(value),
        },
      ],
    },
    {
      name: 'maxStock',
      label: 'Stock de tickets por día',
      type: 'number',
      initialValue: editableRow?.maxStock ?? undefined,
      rules: [
        {
          required: isCreation,
          type: 'number' as const,
          min: 0,
          transform: (value: unknown) => Number(value),
        },
      ],
    },
    {
      name: 'description',
      label: 'Descripción',
      type: 'localizedTextarea',
      initialValue: toFormLocalizedText(editableRow?.description || undefined),
      rules: isCreation
        ? [requiredDefaultLanguage('Campo requerido', isEmptyRichText)]
        : [],
    },
    {
      name: 'isBicycle',
      label: 'Entrada para bicicletas',
      type: 'switch',
      initialValue: editableRow?.isBicycle || false,
      rules: [{ required: isCreation }],
    },
    {
      name: 'features',
      label: featureTexts.title,
      type: 'ticketFeatures',
      initialValue: editableRow?.features || [],
      rules: [{ required: false }],
    },
  ];

  if (isCreation) {
    return formFields;
  }

  return [
    ...formFields,
    {
      name: 'images',
      label: 'Fotos',
      type: 'images',
      uploadelement,
      rules: [{ required: false }],
    },
  ];
};

export default entranceFormFields;
